__webpack_require__.p = "/ResearchersAward/";